import { render, staticRenderFns } from "./ClientsDashboard.vue?vue&type=template&id=6e41600a&scoped=true&"
import script from "./ClientsDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDashboard.vue?vue&type=style&index=0&id=6e41600a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41600a",
  null
  
)

export default component.exports